import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { ManageSupportDocumentMessageComponent } from './components';
import { OneEducationCoreModule } from '@oneeducation/app-core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@shared/shared.module';
import { TextareaModule } from 'primeng/textarea';
import { EditorModule } from 'primeng/editor';

@NgModule({
  declarations: [ManageSupportDocumentMessageComponent],
  imports: [
    CommonModule,
    ButtonModule,
    FormsModule,
    ReactiveFormsModule,
    TextareaModule,
    SharedModule,
    OneEducationCoreModule,
    EditorModule
  ],
  exports: [ManageSupportDocumentMessageComponent]
})
export class SupportDocumentManagementModule {}
